import { getEventPropsBuilder } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';

export const LIVESTREAM_ENTRY_POINT_MODULE = {
    LOBBY: 'entry_zone_lobby',
    INFLUENCER_HUB: 'entry_zone_influencer_hub'
} as const;

export const LIVESTREAM_ENTRY_POINT_LINK_TEXT = {
    CTA: 'go_to_stream',
    THUMBNAIL: 'thumbnail'
} as const;

const ZONE_NAME = 'livestream';

type LivestreamEntryPointModule = (typeof LIVESTREAM_ENTRY_POINT_MODULE)[keyof typeof LIVESTREAM_ENTRY_POINT_MODULE];

type LivestreamEntryPointLinkText =
    (typeof LIVESTREAM_ENTRY_POINT_LINK_TEXT)[keyof typeof LIVESTREAM_ENTRY_POINT_LINK_TEXT];

type ZoneCtaClickedEvent = {
    module: LivestreamEntryPointModule;
    linkText: LivestreamEntryPointLinkText;
};

export const getZoneCtaClickedProps = getEventPropsBuilder(
    (e: ZoneCtaClickedEvent): Partial<AmplitudeEventKeys> => ({
        event: 'Zone CTA Clicked',
        Module: e.module,
        'Zone Name': ZONE_NAME,
        'Link Text': e.linkText
    })
);
